import { render } from "./VaccinationLogTable.vue?vue&type=template&id=259ad5ab&scoped=true"
import script from "./VaccinationLogTable.vue?vue&type=script&lang=js"
export * from "./VaccinationLogTable.vue?vue&type=script&lang=js"

import "./VaccinationLogTable.vue?vue&type=style&index=0&id=259ad5ab&scoped=true&lang=css"

import exportComponent from "/Users/chordarts/pasti/dev10/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-259ad5ab"]])

export default __exports__